import { API_VERSION_ONE, handleAPI } from "../../../../../itrust_common/utils/apiUtils";

const VISION_INSURANCE = 'VISION_INSURANCE_CLAIM_FORM_';

export function visionInsuranceClaimFormCreate(data, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs`;
  const method = 'POST'
  return {
    type: `${VISION_INSURANCE}CREATE`,
    payload: handleAPI(url, filters, method, {  ...data })
  }
}

export function visionInsuranceClaimFormLoad(orderId, filters = {}) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${orderId}/insurance_claim_form`;
  const method = 'GET'
  return {
    type: `${VISION_INSURANCE}LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function visionInsuranceClaimFormUpdate(data, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${data.id}`;
  const method = 'PUT'
  return {
    type: `${VISION_INSURANCE}UPDATE`,
    payload: handleAPI(url, filters, method, { claim_info: { ...data }, attachments_attributes: data.attachments_attributes })
  }
}

// export function visionInsuranceClaimFormChangesSaved(data, storeId, filters) {
//   const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${data.id}?store_id=${storeId}`;
//   const method = 'PUT'
//   const { claim_sections, ...claimInfo } = data
//   return {
//     type: 'VISION_INSURANCE_CLAIM_FORM_UPDATE',
//     payload: handleAPI(url, filters, method, { claim_sections, claim_info: { ...claimInfo } })
//   }
// }
export function visionInsuranceClaimFormSubmit(data, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs`;
  const method = 'POST'
  return {
    type: `${VISION_INSURANCE}SUBMIT`,
    payload: handleAPI(url, filters, method, data)
  }
}

export function visionInsuranceClaimFormTemplateLoad(filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/templates`;
  const method = 'GET'
  return {
    type: `${VISION_INSURANCE}TEMPLATE_LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function frameOptionsLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${id}/frame_options`;
  const method = 'GET'
  return {
    type: `${VISION_INSURANCE}FRAME_OPTIONS_LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function eyemedLenDesignLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${id}/eyemed/lendesign`
  const method = 'GET'
  return {
    type: `${VISION_INSURANCE}EYEMED_LEN_DESIGN_LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function eyemedLenMaterialLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${id}/eyemed/lenmaterial`
  const method = 'GET'
  return {
    type: `${VISION_INSURANCE}EYEMED_LEN_MATERIAL_LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function eyemedSpecialParametersLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${id}/eyemed/specialparameters`
  const method = 'GET'
  return {
    type: `${VISION_INSURANCE}EYEMED_SPECIAL_PARAMETERS_LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function eyemedAvailableLabsLoad(id, filters = {}) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${id}/eyemed/availablelabs`
  const method = 'GET'
  return {
    type: `${VISION_INSURANCE}EYEMED_AVAILABLE_LABS_LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function eyemedAllDiagnosesLoad(id, filters = {}) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${id}/eyemed/alldiagnoses`
  const method = 'GET'
  return {
    type: `${VISION_INSURANCE}EYEMED_ALL_DIAGNOSES_LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function visionInsuranceClaimFormEdit(data) {
  return {
    type: `${VISION_INSURANCE}EDIT`,
    data
  };
}

export function frameOptionsEdit(data) {
  return {
    type: `${VISION_INSURANCE}FRAME_OPTIONS_EDIT`,
    data
  };
}

export function visionInsuranceClaimFormEditReset() {
  return {
    type: `${VISION_INSURANCE}EDIT_RESET`,
  };
}

export function visionInsuranceClaimFormReset() {
  return {
    type: `${VISION_INSURANCE}RESET`,
  };
}
